var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionButton',{attrs:{"color":"secondary"},on:{"click":_vm.onCopy},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('copy-information'))+" ")]},proxy:true}])},[_vm._v(" mdi-content-copy ")])}
var staticRenderFns = []

export { render, staticRenderFns }